import React from 'react'
import styled from '@emotion/styled'

const Icon = styled.svg`
  .cls-1 {
    fill: none;
  }

  .cls-2 {
    clip-path: url(#clip-path);
  }

  .cls-3,
  .cls-4,
  .cls-5,
  .cls-6,
  .cls-7 {
    fill: #fff;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 0.5px;
  }

  .cls-3 {
    opacity: 0.5;
  }

  .cls-5 {
    opacity: 0.7;
  }

  .cls-6 {
    opacity: 0.8;
  }

  .cls-7 {
    opacity: 0.9;
  }
`

export const GroundWaterIcon = () => {
  return (
    <Icon viewBox="0 0 88.7 86.33">
      <defs>
        <clipPath id="clip-path" transform="translate(7.11 10.2)">
          <rect className="cls-1" width="70" height="70" />
        </clipPath>
      </defs>
      <g id="groundwater">
        <g className="cls-2">
          <g>
            <rect className="cls-1" y="4.96" width="55.98" height="79.82" />
            <polygon
              className="cls-3"
              points="60.48 55.55 56.58 51.66 56.58 50.35 52.68 46.46 52.68 45.16 50.72 43.21 50.72 46.46 46.17 51.01 44.22 51.01 39.67 55.55 37.07 55.55 39.02 57.5 39.02 58.8 40.97 60.75 40.97 62.7 42.92 64.64 44.22 64.64 45.52 65.94 45.52 67.24 44.87 67.89 44.87 68.54 45.52 69.19 45.52 73.09 48.77 73.09 56.58 65.29 61.13 65.29 65.03 61.4 60.48 56.85 60.48 55.55"
            />
            <polygon
              className="cls-4"
              points="70.89 32.17 70.89 30.22 70.23 29.58 70.23 28.27 69.58 27.63 69.58 26.98 68.94 26.33 68.28 26.33 68.28 24.38 67.64 23.73 66.33 23.73 66.98 24.38 66.98 32.17 65.68 33.47 65.68 34.12 65.03 34.77 63.73 36.07 63.08 36.07 61.78 37.37 60.48 37.37 57.88 39.97 55.93 39.97 54.63 41.26 52.68 41.26 52.02 41.91 59.83 41.91 64.38 37.37 67.64 37.37 71.53 33.47 71.53 32.82 70.89 32.17"
            />
            <polygon
              className="cls-5"
              points="33.17 80.88 33.17 79.58 32.51 78.93 32.51 77.63 31.21 76.33 24.06 76.33 24.06 76.98 22.76 76.98 22.11 76.33 22.11 75.04 21.46 74.38 21.46 73.74 19.51 71.79 18.21 71.79 14.96 68.54 14.96 67.89 14.3 67.89 13.66 68.54 13.66 70.49 14.3 71.14 14.3 73.09 13.66 73.74 13.66 76.98 12.36 78.28 12.36 80.23 14.3 82.18 17.56 82.18 19.51 84.13 22.76 84.13 24.71 86.08 27.96 86.08 33.17 80.88"
            />
            <polygon
              className="cls-4"
              points="14.3 67.89 14.3 65.94 13.01 65.94 12.36 65.29 9.76 65.29 9.76 68.54 6.5 71.79 6.5 76.98 7.81 76.98 8.45 77.63 8.45 79.58 11.7 79.58 12.36 80.23 12.36 78.28 13.66 76.98 13.66 73.74 14.3 73.09 14.3 71.14 13.66 70.49 13.66 68.54 14.3 67.89"
            />
            <polygon
              className="cls-6"
              points="14.3 51.01 16.26 52.96 16.91 53.6 16.91 56.2 17.56 56.85 17.56 58.8 16.91 59.45 15.61 59.45 14.96 60.1 14.96 62.7 15.61 63.34 15.61 64.64 14.3 65.94 13.01 65.94 12.36 65.29 9.76 65.29 9.76 62.7 11.7 60.75 11.7 56.2 14.3 53.6 14.3 51.01"
            />
            <polygon
              className="cls-4"
              points="17.56 57.5 27.32 57.5 28.62 56.2 33.81 56.2 34.47 55.55 37.07 55.55 39.02 57.5 39.02 58.8 40.97 60.75 40.97 62.7 42.92 64.64 44.22 64.64 45.52 65.94 45.52 67.24 44.87 67.89 44.87 68.54 45.52 69.19 45.52 73.09 40.97 73.09 33.17 80.88 33.17 79.58 32.51 78.93 32.51 77.63 31.21 76.33 24.06 76.33 24.06 76.98 22.76 76.98 22.11 76.33 22.11 75.04 21.46 74.38 21.46 73.74 19.51 71.79 18.21 71.79 14.96 68.54 14.96 67.89 14.3 67.89 14.3 65.94 15.61 64.64 15.61 63.34 14.96 62.7 14.96 60.1 15.61 59.45 16.91 59.45 17.56 58.8 17.56 57.5"
            />
            <polygon
              className="cls-3"
              points="71.53 33.47 71.53 32.82 70.89 32.17 70.89 30.22 70.23 29.58 70.23 28.27 69.58 27.63 69.58 26.98 68.94 26.33 68.28 26.33 68.28 24.38 67.64 23.73 66.98 23.73 65.03 23.73 63.73 22.43 63.08 22.43 61.78 21.13 61.13 21.13 57.88 17.89 57.23 17.89 55.28 15.94 53.98 15.94 59.18 10.74 61.13 10.74 66.33 5.55 68.28 5.55 73.49 0.35 75.44 2.3 75.44 5.55 78.04 8.14 78.04 10.74 81.94 14.64 79.99 16.59 81.94 18.54 85.19 15.29 87.14 17.23 85.84 18.54 88.44 21.13 88.44 22.43 82.59 28.27 79.99 28.27 76.09 32.17 72.83 32.17 71.53 33.47"
            />
            <polygon
              className="cls-6"
              points="18.21 35.42 22.11 35.42 23.41 34.12 23.41 31.52 22.11 30.22 22.11 29.58 21.46 28.93 20.81 28.93 20.16 28.27 20.16 25.68 20.81 25.03 21.46 25.03 22.11 24.38 22.11 23.08 22.76 22.43 22.76 18.54 21.46 17.23 20.81 17.23 20.16 16.59 18.86 16.59 19.51 17.23 19.51 27.63 18.86 28.27 18.86 32.82 18.21 33.47 18.21 35.42"
            />
            <polygon
              className="cls-4"
              points="16.91 34.77 17.56 35.42 18.21 35.42 18.21 33.47 18.86 32.82 18.86 28.27 19.51 27.63 19.51 17.23 18.86 16.59 17.56 17.89 17.56 22.43 18.21 23.08 18.21 28.27 17.56 28.93 17.56 34.12 16.91 34.77"
            />
            <polygon
              className="cls-4"
              points="31.87 19.83 29.91 19.83 29.26 20.48 26.66 20.48 26.01 19.83 24.71 19.83 24.06 20.48 22.76 20.48 22.76 18.54 21.46 17.23 20.81 17.23 20.16 16.59 18.86 16.59 20.81 14.64 25.36 14.64 29.26 18.54 30.57 18.54 31.87 19.83"
            />
            <polygon
              className="cls-4"
              points="42.92 23.73 42.92 25.03 42.27 25.68 42.27 26.98 41.62 27.63 41.62 28.93 40.97 29.58 40.97 30.22 39.67 31.52 38.37 31.52 37.72 32.17 36.42 32.17 35.77 32.82 33.81 32.82 33.17 33.47 31.21 33.47 30.57 34.12 27.32 34.12 26.66 33.47 25.36 33.47 24.71 32.82 23.41 32.82 23.41 31.52 22.11 30.22 22.11 29.58 21.46 28.93 20.81 28.93 20.16 28.27 20.16 25.68 20.81 25.03 21.46 25.03 22.11 24.38 22.11 23.08 22.76 22.43 22.76 20.48 24.06 20.48 24.71 19.83 26.01 19.83 26.66 20.48 29.26 20.48 29.91 19.83 31.87 19.83 35.77 23.73 42.92 23.73"
            />
            <polygon
              className="cls-4"
              points="24.71 32.82 24.71 33.47 25.36 34.12 25.36 35.42 26.01 36.07 26.01 40.62 26.66 41.26 26.66 41.91 26.01 42.56 26.01 48.41 25.36 49.06 25.36 51.66 26.01 52.3 26.01 54.9 24.71 56.2 23.41 56.2 22.11 57.5 17.56 57.5 17.56 56.85 16.91 56.2 16.91 53.6 14.3 51.01 14.3 43.21 15.61 41.91 15.61 38.67 17.56 36.72 17.56 35.42 22.11 35.42 23.41 34.12 23.41 32.82 24.71 32.82"
            />
            <polygon
              className="cls-7"
              points="52.02 15.94 53.98 15.94 55.28 15.94 57.23 17.89 57.88 17.89 61.13 21.13 61.78 21.13 63.08 22.43 63.73 22.43 65.03 23.73 66.33 23.73 66.98 24.38 66.98 32.17 65.68 33.47 65.68 34.12 63.73 36.07 63.08 36.07 61.78 37.37 60.48 37.37 57.88 39.97 55.93 39.97 54.63 41.26 52.68 41.26 52.02 41.91 49.43 41.91 50.72 43.21 50.72 46.46 46.17 51.01 44.22 51.01 39.67 55.55 34.47 55.55 33.81 56.2 28.62 56.2 27.32 57.5 22.11 57.5 23.41 56.2 24.71 56.2 26.01 54.9 26.01 52.3 25.36 51.66 25.36 49.06 26.01 48.41 26.01 42.56 26.66 41.91 26.66 41.26 26.01 40.62 26.01 36.07 25.36 35.42 25.36 34.12 24.71 33.47 24.71 32.82 25.36 33.47 26.66 33.47 27.32 34.12 30.57 34.12 31.21 33.47 33.17 33.47 33.81 32.82 35.77 32.82 36.42 32.17 37.72 32.17 38.37 31.52 39.67 31.52 40.97 30.22 40.97 29.58 41.62 28.93 41.62 27.63 42.27 26.98 42.27 25.68 42.92 25.03 42.92 23.73 44.22 23.73 52.02 15.94"
            />
          </g>
        </g>
      </g>
    </Icon>
  )
}
